import { render, staticRenderFns } from "./HistoryItems.vue?vue&type=template&id=b7b56e86&scoped=true&"
import script from "./HistoryItems.vue?vue&type=script&lang=js&"
export * from "./HistoryItems.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItems.vue?vue&type=style&index=0&id=b7b56e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b56e86",
  null
  
)

export default component.exports